<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <!-- Sidebar para desktop -->
  <app-sidebar [circleNumber]="2" (backClick)="goBack()" class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden"></app-sidebar>
  
  <!-- Header para móvil -->
  <app-header [circleNumber]="2" (backClick)="goBack()"></app-header>

  <!-- Main Content -->
  <div class="flex-1 flex flex-col">
    <app-subheader [circleNumber]="2" class="pt-[60px] md:pt-0"></app-subheader>

    <!-- Form Content -->
    <div class="flex-1 px-4 md:px-[100px] lg:px-[200px] pb-12 md:pb-20 max-w-[800px] mx-auto w-full">
      <h1 class="teu-title text-2xl md:text-[32px] mb-2 md:mb-4 text-center">
        Mi domicilio
      </h1>
      <p class="teu-subtitle text-lg md:text-xl mb-8 md:mb-12 text-center">
        Completa tu información de domicilio
      </p>

      <form [formGroup]="addressForm" class="flex flex-col gap-4 max-w-[500px] mx-auto">
        <!-- Calle -->
        <div class="relative">
          <input
            pInputText
            type="text"
            formControlName="street"
            placeholder="Calle"
            class="w-full"
            [class.border-red-500]="hasError('street')"
          />
          <div *ngIf="hasError('street')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('street') }}
          </div>
        </div>

        <!-- No.Exterior y No.Interior en la misma fila -->
        <div class="flex gap-3">
          <div class="flex-1 relative">
            <input
              pInputText
              type="text"
              formControlName="exteriorNumber"
              placeholder="No.Exterior*"
              class="flex-1"
              [class.border-red-500]="hasError('exteriorNumber')"
            />
            <div *ngIf="hasError('exteriorNumber')" class="text-red-500 text-xs mt-1 font-inter">
              {{ getErrorMessage('exteriorNumber') }}
            </div>
          </div>
          <div class="flex-1 relative">
            <input
              pInputText
              type="text"
              formControlName="interiorNumber"
              placeholder="No.Interior"
              class="flex-1"
              [class.border-red-500]="hasError('interiorNumber')"
            />
            <div *ngIf="hasError('interiorNumber')" class="text-red-500 text-xs mt-1 font-inter">
              {{ getErrorMessage('interiorNumber') }}
            </div>
          </div>
        </div>

        <!-- Código Postal -->
        <div class="relative">
          <input
            pInputText
            type="text"
            formControlName="postalCode"
            placeholder="Código Postal"
            class="w-full"
            maxlength="5"
            (keypress)="onlyNumbers($event)"
            [class.border-red-500]="hasError('postalCode')"
          />
          <div *ngIf="hasError('postalCode')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('postalCode') }}
          </div>
        </div>

        <!-- Colonia -->
        <div class="relative">
          <p-dropdown
            formControlName="colony"
            [options]="colonyOptions"
            placeholder="Colonia"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            [filter]="true"
            filterBy="label"
            [disabled]="!postalCode?.value || postalCode?.value.length !== 5"
            [class.border-red-500]="hasError('colony')"
          ></p-dropdown>
          <div *ngIf="hasError('colony')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('colony') }}
          </div>
        </div>

        <!-- Delegación/Municipio -->
        <div class="relative">
          <p-dropdown
            formControlName="municipality"
            [options]="municipalityOptions"
            placeholder="Delegación/Municipio"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            [filter]="true"
            filterBy="label"
            [disabled]="!postalCode?.value || postalCode?.value.length !== 5"
            [class.border-red-500]="hasError('municipality')"
          ></p-dropdown>
          <div *ngIf="hasError('municipality')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('municipality') }}
          </div>
        </div>

        <!-- Estado -->
        <div class="relative">
          <input
            pInputText
            type="text"
            formControlName="state"
            placeholder="Estado"
            class="w-full"
            readonly
            [class.border-red-500]="hasError('state')"
          />
          <div *ngIf="hasError('state')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('state') }}
          </div>
        </div>

        <!-- Tipo de vivienda -->
        <div class="relative">
          <p-dropdown
            formControlName="housingType"
            [options]="housingTypeOptions"
            placeholder="Tipo de vivienda"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            [class.border-red-500]="hasError('housingType')"
          ></p-dropdown>
          <div *ngIf="hasError('housingType')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('housingType') }}
          </div>
        </div>

        <!-- Años de residencia -->
        <div class="relative">
          <p-dropdown
            formControlName="yearsOfResidence"
            [options]="yearsOfResidenceOptions"
            placeholder="Años de residencia"
            optionLabel="label"
            optionValue="value"
            class="w-full"
            [class.border-red-500]="hasError('yearsOfResidence')"
          ></p-dropdown>
          <div *ngIf="hasError('yearsOfResidence')" class="text-red-500 text-xs mt-1 font-inter">
            {{ getErrorMessage('yearsOfResidence') }}
          </div>
        </div>

        <!-- Botón Confirmar -->
        <button
          type="button"
          class="btn-primary w-full max-w-[300px] h-[46px] mt-6 mx-auto"
          [disabled]="addressForm.invalid"
          [class.opacity-50]="addressForm.invalid"
          [class.cursor-not-allowed]="addressForm.invalid"
          (click)="onSubmit()"
        >
          Confirmar
        </button>
      </form>
    </div>
  </div>
</div>
